<template>
    <div>
        <v-row>
            <v-col cols="12">
                <h3>Teste de Consumo Soluções:</h3>
            </v-col>
        </v-row>
      
        <v-row>
            <!-- Start Table Solutions -->
            <v-data-table
              multi-sort
              :headers="headers"
                :items="filteredSolutionList"
                class="elevation-1"
                style="width: 100%"
                :items-per-page="itemsPerPage"
                :show-select="false"
                :item-key="'id'"
                :custom-filter="() => true"  
            >


   
                <template v-slot:top>
                    <v-row>
                        <v-col cols="6" sm="2" style="background-color: #1976D250;
                            min-width: 150px;
                            border-color: #1976D2;
                            border-bottom: 5px solid #1976D2; 
                            border-radius: 5px;
                            margin-right: 10px;">
                            <span>Economia Média</span>
                            <h2>{{getAverageEconomy}}</h2>
                        </v-col>
                        <v-col cols="6" sm="2" style="background-color: #1976D250;
                            min-width: 150px;
                            border-color: #1976D2;
                            border-bottom: 5px solid #1976D2; 
                            border-radius: 5px;">
                            <span>Soluções</span>
                            <h2>{{getTotalSolutions}}</h2>
                        </v-col>
                    </v-row>
                    <v-toolbar flat class="rounded-lg">
                        <v-toolbar-title>Solução</v-toolbar-title>
                        <v-spacer></v-spacer>
                        
                        <!-- Indicador de soluções modificadas -->
                        <v-chip
                            v-if="modifiedSolutionsCount > 0"
                            color="warning"
                            dark
                            small
                            class="mr-2"
                        >
                            <v-icon left small>mdi-pencil</v-icon>
                            {{ modifiedSolutionsCount }} modificada(s)
                        </v-chip>
                        
                        <v-btn
                            :color="selectedItems.length === 0 ? 'grey' : 'primary'"
                            class="mb-2"
                            text
                            :disabled="selectedItems.length === 0"
                            @click="deleteLot"
                        >
                        <v-icon color="primary" small>mdi-delete</v-icon>
                        </v-btn>

                        <v-btn
                            color="primary"
                            class="mb-2"
                            text
                            @click="() => create()"
                        >
                            <v-icon>add</v-icon>
                        </v-btn>
                    </v-toolbar>
                </template>
                <template v-slot:header.select>
                  <input
                    type="checkbox"
                    :checked="allSelected"
                    :indeterminate.prop="someSelected && !allSelected"
                    @change="toggleSelectAll"
                    class="checkbox-large"
                  />
                </template>
                <template v-slot:item.type="{ item }">
                    {{ convertNameType(item.type) }}
                </template>
                <template v-slot:item.solution="{ item }">
                    {{ convertSolutionName(item.solution) }}
                </template>
                <template v-slot:item.flowRateBefore="{ item }">
                    {{ item.flowRateBefore + " /  " +  item.flowRateAfter}}
                </template>

                <template v-slot:item.status="{ item }">
                    <v-chip
                        v-if="item.isModified"
                        color="warning"
                        dark
                        x-small
                        class="ma-0"
                    >
                        <v-icon left x-small>mdi-pencil</v-icon>
                        Modificada
                    </v-chip>
                    <v-chip
                        v-else
                        color="success"
                        dark
                        x-small
                        class="ma-0"
                    >
                        <v-icon left x-small>mdi-check</v-icon>
                        OK
                    </v-chip>
                </template>

                <template v-slot:item.Img="{ item }">
                    <v-row>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    :color="hasBeforeImage(item) ? 'primary' : 'default'"
                                    class="mr-2">
                                    mdi-image
                                </v-icon>
                            </template>
                            <span>{{ hasBeforeImage(item) ? 'Imagem Antes' : 'Sem Imagem Antes' }}</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    :color="hasAfterImage(item) ? 'primary' : 'default'">
                                    mdi-image
                                </v-icon>
                            </template>
                            <span>{{ hasAfterImage(item) ? 'Imagem Depois' : 'Sem Imagem Depois' }}</span>
                        </v-tooltip>
                    </v-row>
                </template>

                <template v-slot:item.select="{ item }">
                  <input
                    type="checkbox"
                    :checked="selectedItems.includes(item)"
                    @change="toggleItemSelection(item)"
                    class="checkbox-large"
                  />
                </template>

                <template v-slot:item.actions="{ item }">
                    <v-row style="align-items: center;">
                      <v-btn
                          elevation="2"
                          :disabled="isDisabled('edit', item)"
                          @click.stop="confirmDeleteSolution(item)"
                          style="height: 30px; margin: 2px"
                      >
                        <v-icon color="primary" small>mdi-delete</v-icon>
                      </v-btn>
                      <v-btn
                          elevation="2"
                          :loading="loadingForAction('edit') && loadingForActions.index === calculatedIndex(item)"
                          :disabled="isDisabled('delete', item)"
                          @click="edit(item)"
                          style="height: 30px; margin: 2px"
                      >
                        <v-icon color="primary" small>mdi-pencil</v-icon>
                      </v-btn>
                    </v-row>
                </template>


            </v-data-table>
            <!-- End Table Solutions -->
        </v-row>
        <v-dialog 
            transition="dialog-top-transition" 
            v-model="dialog" 
            persistent max-width="700px"
        >
            <v-card>
                <v-toolbar color="primary" dark> <span class="text-h5">Adicionar Solução</span></v-toolbar>
                <v-card-title>
                    <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text style="padding-bottom: 0px;">
                    <v-row>
                        <h3> Informações do Ponto</h3>
                    </v-row>
                    <v-form  ref="testSolutionForm" v-model="validForm" lazy-validation>
                        <v-row>
                            <v-col cols="12" :sm="6">
                                <v-text-field 
                                    v-model="solution.local" 
                                    outlined 
                                    label="Local" 
                                    type="text" 
                                    required
                                    :rules="rulesRequired"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="6">
                                <v-text-field 
                                    v-model="solution.sub_local" 
                                    outlined 
                                    label="Sub-Local" 
                                    type="text" 
                                    required
                                    :rules="rulesRequired"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="solution.pipingType ? 6 : 4">
                                <v-autocomplete 
                                    label="Tipo" 
                                    :items="pointsData" 
                                    item-text="name"
                                    item-value="id" 
                                    outlined 
                                    v-model="solution.type"
                                    @change="optionTypeSelect(solution.type)" 
                                    :rules="rulesRequired" 
                                    onfocus
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col v-if="solution.pipingType" cols="12" :sm="solution.pipingType ? 6 : 4">
                                <v-select
                                    :items="pipingTypesList"
                                    v-model="solution.pipingType"
                                    label="Tipo da Tubulação"
                                    outlined
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="solution.pipingType ? 6 : 4">
                                <v-autocomplete label="Soluções" 
                                    :items="solutionsOptionsList" 
                                    v-model="solution.solution" 
                                    outlined
                                    item-text="solution"
                                    item-value="id"
                                    :rules="rulesRequired"
                                    :disabled="loading || solution.type === null"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="solution.pipingType ? 6 : 4">
                                <NumberInput 
                                    v-model="solution.amountSolution" 
                                    :label="'Qtnd.'"
                                    :suffix="''"
                                    outlined
                                    required
                                    :rules="rulesRequired"
                                />
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" :sm="4">
                                <NumberInput
                                    v-model="solution.flowRateBefore"
                                    :label="'Vazão antes'"
                                    :suffix="'L/min'"
                                    outlined
                                    :isFloat="true"
                                    :rules="rulesRequired"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="4">
                                <NumberInput
                                    v-model="solution.flowRateAfter" 
                                    :label="'Vazão Depois'"
                                    :suffix="'L/min'"
                                    outlined
                                    :isFloat="true"
                                    :rules="rulesRequired"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="4">
                                <v-select
                                    :items="flowTypeList"
                                    v-model="solution.flowRateType"
                                    label="Tipo do fluxo"
                                    outlined
                                    :rules="rulesRequired"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12">
                                <v-text-field 
                                    v-model="solution.economy" 
                                    outlined 
                                    label="Economia" 
                                    readonly 
                                    suffix="%"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                            <v-col cols="12" :sm="12">
                                <v-textarea 
                                    v-model="solution.comments" 
                                    outlined 
                                    label="Observação" 
                                    type="text"
                                    :disabled="loading"
                                    :loading="loading"
                                />
                            </v-col>
                        </v-row>
                    </v-form>
                    <v-row>
                        <v-col cols="6">
                            <InputFiles
                                title="Foto Antes"
                                :loading="loadingImage"
                                :fileTypes="['image']"
                                :showFile="solution.file_before_solution"
                                @change:file="(file) => handleImageChange('before', file)"
                            />
                        </v-col>
                        <v-col cols="6">
                            <InputFiles
                                title="Foto Depois"
                                :loading="loadingImage"
                                :fileTypes="['image']"
                                :showFile="solution.file_after_solution"
                                @change:file="(file) => handleImageChange('after', file)"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="() => closeDialog()"
                        :disabled="loading"
                        :loading="loading"
                    >Cancelar</v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="() => save(false)"
                        :disabled="loading || !validForm"
                        :loading="loading"
                    >Adicionar e fechar</v-btn>
                    <v-btn 
                        color="blue darken-1" 
                        text 
                        @click="() => save(true)"
                        :disabled="loading || !validForm"
                        :loading="loading"
                        v-if="isAdd"
                    >Adicionar e continuar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
  
<script>
import InputFiles from "@/components/Forms/Input/input-files.vue";
import WaterScanStoragefrom from '@/services/storage/WaterScanStorage';
import { showDeleteDialogAlert } from "@/utils/DialogAlertHelper";
import SolutionsServices from '@/services/firebase/SolutionsServices/SolutionsServices';
import DiagnosticServiceFirebase from "@/services/firebase/Diagnostic/DiagnosticService";
import SolutionsPoint from '@/services/firebase/SolutionsPoint/SolutionsPoint';
import DiagnosticStorage from '@/services/storage/DiagnosticStorage';
import Rules from "@/utils/Rules";
import cloneDeep from 'lodash/cloneDeep';
import { mapGetters } from "vuex";
import NumberInput from "../../../../Inputs/NumberInput.vue";

import SolutionListModel from '@/objects/Waterscan/CheckListTab/SolutionListModel.js'
import VueHorizontal from 'vue-horizontal';


const newSolution = () => {
    return {
        amountSolution: "",
        flowRateBefore: "",
        flowRateAfter: "",
        file_before_solution: null,
        file_after_solution: null,
        local: "",
        sub_local: "",
        solution: "",
        type: "",
        pipingType: "",
        flowRateType: "PROJETADA",
        economy: 0,
        comments: "",
        imgNameList: [],
        isModified: false,
    }
}

const PIPING_POINT_ID = "vIEqBb4EEnWAJU5HbYXs"

export default {
    name: "SolutionList",
    
    components: {
        VueHorizontal,
        NumberInput,
        InputFiles
    },
    
    props: {
        list: {
            type: Array,
            default: () => ([]),
        },
        add: {
            type: Function,
            default: (solution, index) => {}
        },
        remove: {
            type: Function,
            default: (index) => {}
        },
        projectId: {
            type: String,
            default: null,
        },
        proposalType: {
            type: String,
            default: null // Tipo de proposta para filtrar soluções (ex: 'kit_sell')
        },
    },
    
    data: () => ({
        solution: newSolution(),
        solutionList: [],
        dialog: false,
        index: -1,
        loading: false,
        loadingForActions: {},
        loadingImage: false,
        validForm: true,
        isAdd: true,
        headers: [
            { text: "", value: 'select', maxWidth: 50, sortable: false },
            { text: "Local", value: "local",  maxWidth: 130,sortable: true },
            { text: "Sub local", value: "sub_local", sortable: true },
            { text: "Tipo", value: "type", width: 130, sortable: true },
            { text: "Solução", value: "solution", width: 200, sortable: true },
            { text: "Quantidade", value: "amountSolution", width: 100, sortable: true },
            { text: "Vazão(L) Antes/Depois", value: "flowRateBefore", width: 130, sortable: true },
            { text: "Economia (%) ", value: "economy", sortable: true },
            { text: "Observação", value: "comments", sortable: true },
            { text: "Status", value: "status", width: 80, sortable: false },
            { text: "Img", value: "Img", sortable: false },
            { text: "Ações", value: "actions", sortable: false },
        ],
        optionsType: [
            { text: "Torneira", value: "faucet" },
            { text: "Chuveiro", value: "shower" },
            { text: "Descarga", value: "discharge" },
        ],
        pipingTypesList: SolutionListModel.getPipingTypeList(),
        flowTypeList: SolutionListModel.getFlowTypeList(),
        solutionsData: [],
        pointsData: [],

        listImgs: [],
        editedItem: {},
        deleteImgFile: {},
        rawFiles: [],
        itemsPerPage: 5,
        localList: [],
        selectedItems: [],
    }),

    computed: {
        ...mapGetters([
            "getCurrentUser",
        ]),
        rulesRequired() {
            return Rules.required();
        },
        solutionsOptionsList() {
            return this.optionTypeSelect(this.solution.type)
        },
        getAverageEconomy() {
            if (this.filteredSolutionList.length ) {
                const totalConsumption = this.filteredSolutionList.reduce((sum, item) => sum + (item.economy * item.amountSolution), 0);
                return `${(totalConsumption / this.getTotalSolutions).toFixed(2)} %`
            }
            return 0
        },
        getTotalSolutions() {
            if (this.filteredSolutionList.length ) {
                const totalConsumption = this.filteredSolutionList.reduce((sum, item) => sum + Number(item.amountSolution), 0);
                return (totalConsumption)
            }
            return 0
        },
        isFranchisee(){
            return this.getCurrentUser.data.rank === "Franqueado"
        },
        allSelected() {
            return this.filteredSolutionList.length > 0 && this.selectedItems.length === this.filteredSolutionList.length;
        },
        someSelected() {
            return this.selectedItems.length > 0 && this.selectedItems.length < this.filteredSolutionList.length;
        },
        filteredSolutionList() {
            return this.solutionList.filter(item => item.isDeleted !== true);
        },
        modifiedSolutionsCount() {
            return this.filteredSolutionList.filter(item => item.isModified).length;
        }
    },

    methods: {
        create() {
            this.isAdd = true
            this.index = -1
            this.solution = newSolution()
            // Marca novas soluções como modificadas
            this.solution.isModified = true
            this.dialog = true
            this.selectedItems = []
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs.testSolutionForm) {
                        this.$refs.testSolutionForm.resetValidation()
                        const formElement = this.$refs.testSolutionForm.$el
                        formElement.scrollIntoView({behavior: 'smooth', block: 'start' })
                    }
                }, 100)
            })
        },
        loadingForAction(actionType) {
            return this.loadingForActions && this.loadingForActions.action === actionType;
        },
        isDisabled(actionType, item) {
            const currentIndex = this.calculatedIndex(item);
            return (this.index !== -1) && this.loadingForActions &&
                (this.loadingForActions.index !== currentIndex || this.loadingForActions.action === actionType);
        },
        calculatedIndex(item) {
          return this.list.findIndex(solution => solution === item);
        },
        checkIfHasImg(item) {
          return !!((item.path_before_solution || item.path_after_solution) || (item.file_before_solution || item.file_after_solution));
        },
        async getImages(data){
            try {
                // Carrega as imagens em paralelo
                const [beforeImage, afterImage] = await Promise.all([
                    data.path_before_solution ? DiagnosticStorage.downloadImg(data.path_before_solution) : null,
                    data.path_after_solution ? DiagnosticStorage.downloadImg(data.path_after_solution) : null
                ]);

                // Atualiza os dados apenas se as imagens foram carregadas com sucesso
                if (beforeImage) data.file_before_solution = beforeImage;
                if (afterImage) data.file_after_solution = afterImage;

            } catch (error) {
                console.error('SolutionList - Erro ao carregar imagens:', error);
                // Mantém os paths mesmo se houver erro no download
                data.file_before_solution = null;
                data.file_after_solution = null;
            }
        },
        handleImageChange(type, file) {
            if (type === 'before') {
                if (!file) {
                    this.solution.path_before_solution = null;
                    this.solution.file_before_solution = null;
                } else {
                    this.solution.path_before_solution = null;
                    this.solution.file_before_solution = file;
                }
            } else {
                if (!file) {
                    this.solution.path_after_solution = null;
                    this.solution.file_after_solution = null;
                } else {
                    this.solution.path_after_solution = null;
                    this.solution.file_after_solution = file;
                }
            }
        },
        async edit(item) {
            this.isAdd = false
            this.index = this.list.findIndex(solution => solution === item)
            this.loadingForActions = { index: this.index, action: 'edit' };
            
            this.solution = cloneDeep({...item, isModified: true})
            
            this.loadingImage = true
            await this.getImages(this.solution)
            this.loadingImage = false
            this.dialog = true

            this.loadingForActions = null;
        },
        async save(continueAdding) {
            if (!this.$refs.testSolutionForm.validate()) return
            this.loading = true
            
            // Marca a solução como modificada sempre que for adicionada ou editada
            this.solution.isModified = true;
            
            this.add(cloneDeep(this.solution), this.index)
            this.solution = newSolution()
            this.selectedItems = []
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.$refs.testSolutionForm) {
                        this.$refs.testSolutionForm.resetValidation()
                        const formElement = this.$refs.testSolutionForm.$el
                        formElement.scrollIntoView({behavior: 'smooth', block: 'start' })
                    }
                }, 100)
            })
            this.loading = false
            this.dialog = continueAdding
        },
        closeDialog() {
            this.dialog = false
        },
        optionTypeSelect(type_id) {
            return this.solutionsData.filter(({pointId}) => pointId == type_id)
        },
        async listSolutions(){
            let allSolutions = await SolutionsServices.GetSolutions()
            // Filtrar soluções baseado no tipo de proposta
            if (this.proposalType === 'kit_sell') {
                console.log('Filtrando soluções para kit_sell. Total de soluções:', allSolutions.length);
                this.solutionsData = allSolutions.filter(solution => {
                    // Se não tem allowedProposalTypes definido, NÃO permite (só permite se explicitamente marcado)
                    if (!solution.allowedProposalTypes || solution.allowedProposalTypes.length === 0) {
                        return false;
                    }
                    // Se tem allowedProposalTypes, verifica se inclui kit_sell
                    const includes = solution.allowedProposalTypes.includes('kit_sell');
                    if (includes) {
                        console.log('Solução permitida:', solution.solution, solution.allowedProposalTypes);
                    }
                    return includes;
                });
                console.log('Soluções filtradas:', this.solutionsData.length);
            } else {
                this.solutionsData = allSolutions;
            }
        },
        async listSolutionsToFranchisees(){
            let allSolutions = await SolutionsServices.GetSolutionsToFranchisee()
            // Filtrar soluções baseado no tipo de proposta
            if (this.proposalType === 'kit_sell') {
                console.log('Filtrando soluções para kit_sell (franchisee). Total de soluções:', allSolutions.length);
                this.solutionsData = allSolutions.filter(solution => {
                    // Se não tem allowedProposalTypes definido, NÃO permite (só permite se explicitamente marcado)
                    if (!solution.allowedProposalTypes || solution.allowedProposalTypes.length === 0) {
                        return false;
                    }
                    // Se tem allowedProposalTypes, verifica se inclui kit_sell
                    const includes = solution.allowedProposalTypes.includes('kit_sell');
                    if (includes) {
                        console.log('Solução permitida (franchisee):', solution.solution, solution.allowedProposalTypes);
                    }
                    return includes;
                });
                console.log('Soluções filtradas (franchisee):', this.solutionsData.length);
            } else {
                this.solutionsData = allSolutions;
            }
        },
        async listPoints(){
            let pointIds = this.solutionsData.map((item) => item.type == 'Produto' ? item.pointId : null).filter((item) => item !== null && item !== undefined)
            let response =  await SolutionsPoint.GetSolutionsPointByIds(pointIds)
            this.pointsData = Object.values(response)
        },
        calculateEconomy() {
            let flowRateBefore = Number(this.solution.flowRateBefore)
            let flowRateAfter = Number(this.solution.flowRateAfter)
            if (flowRateBefore == 0 || flowRateAfter > flowRateBefore){
                this.solution.economy = 0
                return 0  
            } 
            let economy = 100 - ((flowRateAfter / flowRateBefore) * 100)
            economy = parseFloat(Math.abs(economy).toFixed(2))
            this.solution.economy = economy
        },
        verifyPipingType() {
            let type = this.solution.type
            let pipingType = this.solution.pipingType
            if (type !== PIPING_POINT_ID) {
                this.solution.pipingType = ""
            } else if(pipingType === "") {
                this.solution.pipingType = "PVC"
            }
        },
        verifyFlowRateType() {
            let flowRateType = this.solution.flowRateType
            if (flowRateType === "") {
                this.solution.flowRateType = "REAL"
            }
        },
        convertNameType(pointId){
            const type = this.pointsData.filter(({id}) => id == pointId)
            return type.length > 0 ? type[0].name : "Não Existe"
        },
        convertSolutionName(solutionId){
            const solutionFilter = this.solutionsData.filter(({id}) => id == solutionId)
            return solutionFilter.length > 0? solutionFilter[0].solution : "Não Existe"
        },
        async confirmDeleteSolution(item) {
            showDeleteDialogAlert(`Deseja excluir esse item ${item.local}?`, async () => {
                this.remove(item)
                this.selectedItems = this.selectedItems.filter(i => i !== item)
            })
        },
        changeColorIconListImg(solution) {
            if(solution.imgNameList && solution.imgNameList.length > 0)return "primary"
            return ""
        },
        hasBeforeImage(item) {
            return !!(item.path_before_solution || item.file_before_solution);
        },
        hasAfterImage(item) {
            return !!(item.path_after_solution || item.file_after_solution);
        },
        deleteLot() {
          if (this.selectedItems.length === 0) return;
          showDeleteDialogAlert(
            `Deseja excluir ${this.selectedItems.length} item(ns) selecionado(s)?`,
            () => {
              this.selectedItems.forEach(item => {
                this.remove(item);
              });
              this.selectedItems = [];
            }
          );
        },
        toggleSelectAll() {
            if (this.allSelected) {
                this.selectedItems = [];
            } else {
                this.selectedItems = [...this.filteredSolutionList];
            }
        },
        toggleItemSelection(item) {
            const idx = this.selectedItems.indexOf(item);
            if (idx === -1) {
                this.selectedItems.push(item);
            } else {
                this.selectedItems.splice(idx, 1);
            }
        },
    },

    watch: {
        dialog(newValue) {
            if (!newValue) {
                this.listImgs = [];
                this.editedItem = {};
                this.deleteImgFile = {};
                this.rawFiles = [];
                this.selectedItems = []
            }
        },
        list:{
            deep: true, 
            handler(newValue){
                this.solutionList = newValue
                this.selectedItems = this.selectedItems.filter(item => newValue.includes(item))
            }
        },
        'solution.flowRateBefore': function (newValue) {
            this.calculateEconomy()
        },
        'solution.flowRateAfter': function (newValue) {
            this.calculateEconomy()
        },
        'solution.type': function (newValue) {
            this.verifyPipingType()
        },
        'solution.flowRateType': function () {
            this.verifyFlowRateType()
        },
        proposalType: {
            handler: async function(newVal) {
                // Recarregar soluções quando o tipo de proposta mudar
                if (this.getCurrentUser.data.rank === "Super Admin" || this.getCurrentUser.data.rank === "Admin") { 
                    await this.listSolutions();
                } else if(this.isFranchisee){
                    await this.listSolutionsToFranchisees();
                }
                await this.listPoints();
            },
            immediate: false
        }
    },

    async created() {
        if (this.getCurrentUser.data.rank === "Super Admin" || this.getCurrentUser.data.rank === "Admin") { 
            await this.listSolutions();
        }else if(this.isFranchisee){
            await this.listSolutionsToFranchisees();
        }
        await this.listPoints()
    }

};
</script>
  
<style scoped>
.checkbox-large {
  transform: scale(1.5); /* Aumenta 1.5x, ajuste conforme necessário */
  margin-right: 8px;
  cursor: pointer;
}
</style>